import React from "react";

function NewFranchisee() {
  return (
    <div className="body-content">
      <div class="letters-color-section">
        <div class="main_header">New Franchisee Procedure</div>
        <div class="main-container Itsmc">
          <div class="main-header">
            Appointment of Franchisees for Advance Reservation-Notification
          </div>
          <div class="report-item-list">
            <ul>
              <li>
                Appointment of Franchisees of Advance reservation of seats in
                Bengaluru City and other places of Karnataka State
              </li>
              <li>
                Procedure for appointment of new franchisees at places outside
                the state of karnataka
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NewFranchisee;
